export default "__VITE_ASSET__C$KU2056__"